import { Button } from "../components/Button";
import { SectionHeader } from "../components/SectionHeader";
import { navigateTo } from "../lib/navigation";

const eventTypes = ["Date nights", "Birthdays", "Corporate dinners", "Pop-ups", "Brunch tables", "Cocktail nights"];

export function EventsPage() {
  return (
    <main className="page-shell">
      <section className="split-hero dark-split" id="celebrations">
        <div>
          <p className="eyebrow">Gatherings with flavor</p>
          <h1>Events that feel personal, polished, and easy to host.</h1>
          <p>
            From a small dinner party to a room full of friends, OJ's Bistro builds the table,
            menu, and service around the occasion.
          </p>
          <Button onClick={() => navigateTo("/private-chef")}>Plan an event</Button>
        </div>
        <img src="/assets/site/hero-dining-table.jpg" alt="OJ's Bistro private event table" />
      </section>
      <section className="content-section" id="event-ideas">
        <SectionHeader title="Event Ideas" centered />
        <div className="tag-cloud">
          {eventTypes.map((type) => (
            <span key={type}>{type}</span>
          ))}
        </div>
      </section>
    </main>
  );
}
